(function () {
  'use strict';

  function formatMoney(cents, format) {
    cents = parseInt(cents, 10) || 0;

    var amount = (cents / 100).toFixed(2);
    var amountComma = amount.replace('.', ',');
    var amountNoDecimals = Math.round(cents / 100).toString();

    return (format || '{{amount}} €')
      .replace('{{amount_with_comma_separator}}', amountComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }

  function readCents(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n;
  }

  function getCardState(card) {
    var qty = readCents(card.getAttribute('data-qty'));
    var unitPrice = readCents(card.getAttribute('data-unit-price'));
    var manualTotal = readCents(card.getAttribute('data-manual-total-price'));
    var manualCompare = readCents(card.getAttribute('data-manual-compare-price'));

    var total = manualTotal > 0 ? manualTotal : unitPrice * qty;
    var compare = manualCompare > total ? manualCompare : 0;

    return {
      qty: qty > 0 ? qty : 1,
      unitPrice: unitPrice,
      totalPrice: total,
      comparePrice: compare,
      hasManualPrice: manualTotal > 0
    };
  }

  function updateCardPrice(card, moneyFmt) {
    var state = getCardState(card);
    var priceEl = card.querySelector('[data-wbuq-price]');
    var compareEl = card.querySelector('[data-wbuq-compare]');

    if (priceEl) priceEl.textContent = formatMoney(state.totalPrice, moneyFmt);

    if (compareEl) {
      if (state.comparePrice > state.totalPrice) {
        compareEl.textContent = formatMoney(state.comparePrice, moneyFmt);
        compareEl.style.display = '';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }
  }

  function initBlock(block) {
    if (block.getAttribute('data-wbuq-initialized') === 'true') return;
    block.setAttribute('data-wbuq-initialized', 'true');

    var cards = block.querySelectorAll('[data-wbuq-card]');
    var moneyFmt = block.getAttribute('data-money-format') || '{{amount}} €';
    var sectionId = block.getAttribute('data-section-id');

    if (!cards.length) return;

    function selectCard(card, shouldDispatch) {
      cards.forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');

      updateCardPrice(card, moneyFmt);

      var state = getCardState(card);

      if (shouldDispatch !== false) {
        document.dispatchEvent(new CustomEvent('wbp:qty-override', {
          bubbles: true,
          detail: {
            sectionId: sectionId,
            qty: state.qty,
            unitPrice: state.unitPrice,
            totalPrice: state.totalPrice,
            comparePrice: state.comparePrice,
            hasManualPrice: state.hasManualPrice
          }
        }));
      }
    }

    cards.forEach(function (card) {
      updateCardPrice(card, moneyFmt);

      card.addEventListener('click', function () {
        selectCard(card, true);
      });
    });

    document.addEventListener('wbp:variant-change', function (e) {
      if (!e.detail || e.detail.sectionId !== sectionId) return;

      var newPrice = readCents(e.detail.price);

      cards.forEach(function (card) {
        card.setAttribute('data-unit-price', newPrice);
        updateCardPrice(card, moneyFmt);
      });

      var selected = block.querySelector('[data-wbuq-card].is-selected');
      if (selected) selectCard(selected, true);
    });

    var selected = block.querySelector('[data-wbuq-card].is-selected') || cards[0];
    if (selected) selectCard(selected, true);
  }

  function init(container) {
    var blocks = container.querySelectorAll('[data-wbuq-block]');
    blocks.forEach(function (block) { initBlock(block); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();